<script setup>
import { useNavStore, useLocaleStore } from "@/stores";
import QuestionnaireSelector from "@/views/devTools/QuestionnaireSelector.vue";
const navStore = useNavStore();
const localeStore = useLocaleStore();

const version = __APP_VERSION__;
</script>

<template>
  <div
    class="print:hidden flex justify-between fixed bottom-0 mx-auto left-0 right-0 bg-slate-950 bg-opacity-80 p-3"
  >
    <div class="flex items-center">
      <span class="text-xs text-orange-300 mr-2"
        >Test mode | v{{ version }}</span
      >
      <button
        class="text-xs bg-gray-300 text-black py-1 px-2 rounded-sm mr-2"
        @click="
          () => {
            navStore.push({ name: 'welcome' });
          }
        "
      >
        Welcome
      </button>
      <button
        class="text-xs bg-gray-300 text-black py-1 px-2 rounded-sm mr-2"
        @click="
          () => {
            navStore.push({ name: 'criteria' });
          }
        "
      >
        Criteria
      </button>
      <button
        class="text-xs bg-gray-300 text-black py-1 px-2 rounded-sm mr-2"
        @click="
          () => {
            navStore.push({ name: 'consent' });
          }
        "
      >
        Consent
      </button>
      <button
        class="text-xs bg-gray-300 text-black py-1 px-2 rounded-sm mr-2"
        @click="
          () => {
            navStore.push({ name: 'contact_form' });
          }
        "
      >
        Contact
      </button>
      <QuestionnaireSelector />
      <button
        class="text-xs bg-gray-300 text-black py-1 px-2 rounded-sm mr-2"
        @click="
          () => {
            navStore.push({ name: 'conclusion' });
          }
        "
      >
        Conclusion
      </button>
    </div>
    <div class="flex flex-row text-sm text-gray-400">
      <div
        class="cursor-pointer mr-2 hover:text-white"
        @click="localeStore.setLocale('fr')"
      >
        Fr
      </div>
      <div
        class="cursor-pointer hover:text-white"
        @click="localeStore.setLocale('en')"
      >
        En
      </div>
    </div>
  </div>
</template>
